function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { DetailContainer } from "../../components/container-activity";
import { BaseDataViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { MDCFormRadio, MDCFileUpload } from '../../../jsx/components/mdc-components';
import DataTypes from './data-types';
import { manageDataLegacyHere } from '../../functions/tenant-features';
import { AlertMessage } from '../../ui/alert';
import ProgressSuccess from '../../ui/progress/success';
import endpoints from "../../endpoints";
import account from "../../data/account";
import FileUpload from './upload';
import Fetch from './fetch';
import FetchKit from './fetch-kit';
import { downloadTemplate, PRODUCT_COLUMNS, PRODUCT_SPEC_URL } from "../../functions/csv-templates";
import ServiceFactory from '../../service';
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onChange", event => {
      var target = event.target;
      var value = target.value;
      this.setState({
        audience: value
      });
    });
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onFocus", event => {
      this.setState({
        showMessage: false,
        messageType: '',
        message: null
      });
    });
    _defineProperty(this, "onContinueClick", event => {
      //this.props.history.push('/Product/Update');
      if (this.state.uploadType === 'manual') {
        this.setState({
          showUploadScreen: true,
          showDefaultScreen: false
        });
      } else if (this.state.uploadType === 'fetch') {
        this.setState({
          showFetchScreen: true,
          showDefaultScreen: false
        });
      }
    });
    _defineProperty(this, "onCheckedChange", event => {
      var target = event.target;
      this.setState({
        uploadType: target.id
      });
    });
    _defineProperty(this, "onSaveFetch", model => {
      if (this.verifyFetchModel(model)) {
        this.submitFetch(model);
      } else {
        this.setState({
          showMessage: true,
          messageType: 'error',
          message: 'Add the web address of your file.',
          icon: 'error_outline'
        });
      }
    });
    _defineProperty(this, "onUploadBack", event => {
      this.setState({
        showUploadScreen: false,
        showDefaultScreen: true,
        showMessage: false,
        uploadType: ''
      });
    });
    _defineProperty(this, "onFetchBack", event => {
      this.setState({
        showFetchScreen: false,
        showDefaultScreen: true,
        showMessage: false,
        uploadType: ''
      });
    });
    _defineProperty(this, "onUploadError", obj => {
      console.log(obj);
      this.count = 0;
      this.setState({
        showMessage: true,
        messageType: 'error',
        message: 'Error: Error uploading file.'
      });
    });
    _defineProperty(this, "onUploadComplete", obj => {
      this.count = 0;
      this.setState({
        showSuccess: true,
        showMessage: false,
        messageType: '',
        message: null,
        icon: null,
        showUploadScreen: false,
        showDefaultScreen: false,
        showFetchScreen: false
      });
    });
    _defineProperty(this, "onUploadProgressComplete", () => {
      this.setState({
        showMessage: true,
        messageType: '',
        message: 'Processing uploaded file.'
      });
    });
    _defineProperty(this, "onBeforeUpload", files => {
      //await Plunk360Service.refreshTokenCheckAsync();
      //
      this.handleUpload(files);
    });
    _defineProperty(this, "handleUpload", files => {
      if (this.count > 0) return false;
      var headers = [{
        key: 'authorization',
        value: ''
      }, {
        key: 'X-APP-ID',
        value: this.state.appId
      }];
      this.fileUpload.upload.headers = headers;
      this.count = 1;
      this.fileUpload.upload.resume(files);
    });
    _defineProperty(this, "deleteSchedule", () => {
      var Service = ServiceFactory.getType('/product/schedule', 'product');
      var service = new Service();
      service.delete(() => {
        this.setState({
          showMessage: true,
          messageType: '',
          message: 'Your scheduled pickup has been deleted.',
          icon: 'check_circle_outline',
          showDeleteButton: false
        });
      });
    });
    _defineProperty(this, "downloadFile", url => {
      try {
        download(url);
      } catch (e) {
        window.open(url, "_blank");
      }
    });
    this.state = this.initState();
  }
  initState() {
    var postUrl = endpoints.product.root + '/product/upload';
    var accountData = account.get();
    var showDeleteButton = false;
    if (this.props.data) {
      showDeleteButton = true;
    }
    return {
      showUploadSuccess: false,
      showDefaultScreen: true,
      showFetchScreen: false,
      showUploadScreen: false,
      showMessage: false,
      showDeleteButton: showDeleteButton,
      messageType: '',
      message: null,
      icon: null,
      postUrl: postUrl,
      appId: accountData.tenantId,
      uploadType: ''
    };
  }
  resetState() {
    this.setState({
      showMessage: false,
      messageType: '',
      message: null
    });
  }
  componentDidMount() {
    this.count = 0;
    publishSearch('Product');
    publishEvent('reset-search', {});
  }
  submitFetch(model) {
    var messageType = '';
    var message = '';
    var icon = '';
    var Service = ServiceFactory.getType('/product/schedule', 'product');
    var service = new Service();
    service.put(model, (err, data) => {
      if (!err) {
        messageType = 'success';
        message = 'Saved. Plunk will pick up your file on that schedule.';
        icon = 'check_circle_outline';
      } else {
        messageType = 'error';
        message = "That didn't save. Check the web address and try again.";
        icon = 'error_outline';
        console.log(err);
      }
      this.setState({
        showMessage: true,
        messageType: messageType,
        message: message,
        icon: icon
      });
    });
  }
  verifyFetchModel(model) {
    var valid = false;
    if (model.frequency && model.hour && model.timezone && model.url) {
      valid = true;
    }
    return valid;
  }
  render() {
    if (manageDataLegacyHere()) return this.renderLegacy();
    const st = this.state;
    const msg = st.showMessage ? /*#__PURE__*/React.createElement("div", {
      className: "aup-msg" + (st.messageType === 'error' ? " bad" : "")
    }, String(st.message || "").replace(/^Error:\s*/, "")) : null;
    const choice = (id, title, text) => /*#__PURE__*/React.createElement("label", {
      className: "aup-choice" + (st.uploadType === id ? " on" : "")
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "radio-upload",
      id: id,
      checked: st.uploadType === id,
      onChange: this.onCheckedChange
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("span", null, text)));
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view ec-view ecc-view aup-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ecc-top"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-back",
      "aria-label": "Back",
      onClick: st.showDefaultScreen || st.showSuccess ? this.onGoBack : st.showFetchScreen ? this.onFetchBack : this.onUploadBack
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M10 3L5 8l5 5",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ecc-titleblock"
    }, /*#__PURE__*/React.createElement("span", {
      className: "aup-title"
    }, "Update products"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-meta"
    }, "Your catalog powers product pages, forecasts, demand gaps and Studio.")), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    })), st.showSuccess ? /*#__PURE__*/React.createElement("section", {
      className: "aup-card aup-done"
    }, /*#__PURE__*/React.createElement("b", null, "Your products are uploading"), /*#__PURE__*/React.createElement("span", null, "The catalog updates within a few minutes. Large files can take longer."), /*#__PURE__*/React.createElement("span", {
      className: "aup-actions"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      onClick: () => this.props.history.push("/Product")
    }, "Go to your catalog"))) : st.showDefaultScreen ? /*#__PURE__*/React.createElement("div", {
      className: "aup-steps"
    }, /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "How should Plunk get your products?"), /*#__PURE__*/React.createElement("div", {
      className: "aup-choices"
    }, choice("fetch", "Pick up a file from your website", "You keep a product file at a web address and Plunk collects it on a schedule, so the catalog stays current."), choice("manual", "Upload a file now", "Send a file from your computer once. Use this for a first load or a quick fix.")), /*#__PURE__*/React.createElement("span", {
      className: "aup-actions"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: !st.uploadType,
      onClick: this.onContinueClick
    }, "Continue")), msg)) : st.showFetchScreen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FetchKit, {
      data: this.props.data,
      onSaveFetch: this.onSaveFetch,
      onFetchBack: this.onFetchBack,
      onDeleteFetch: st.showDeleteButton ? this.deleteSchedule : null
    }), msg ? /*#__PURE__*/React.createElement("div", {
      className: "aup-msgrow"
    }, msg) : null) : /*#__PURE__*/React.createElement("div", {
      className: "aup-steps"
    }, /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "aup-row"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "1 \xB7 Get your file ready"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: () => window.open(PRODUCT_SPEC_URL, "_blank", "noopener")
    }, "What each column means"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: () => downloadTemplate("product-template.csv", PRODUCT_COLUMNS)
    }, "Download a template")), /*#__PURE__*/React.createElement("span", {
      className: "aup-hint"
    }, "A CSV or text file with one row per product. These columns are used when they're there:"), /*#__PURE__*/React.createElement("div", {
      className: "aup-datatypes"
    }, /*#__PURE__*/React.createElement(DataTypes, null))), /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "2 \xB7 Upload the file"), /*#__PURE__*/React.createElement(MDCFileUpload, {
      cls: "aup-drop",
      singleFileUpload: true,
      postUrl: st.postUrl,
      onBeforeUpload: this.onBeforeUpload,
      onUploadError: this.onUploadError,
      onUploadComplete: this.onUploadComplete,
      onUploadProgressComplete: this.onUploadProgressComplete,
      ref: ref => {
        this.fileUpload = {
          upload: ref
        };
      },
      accept: ".csv,.txt"
    }), msg)));
  }
  renderLegacy() {
    return /*#__PURE__*/React.createElement(DetailContainer, {
      title: "Manage Product",
      onGoBack: this.onGoBack
    }, this.state.showSuccess && /*#__PURE__*/React.createElement(ProgressSuccess, {
      message: "Your product file has been successfully uploaded."
    }), this.state.showDefaultScreen && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "Choose how to setup your feed and connect your product data to Plunk."), /*#__PURE__*/React.createElement("div", {
      className: "margin-top"
    }, /*#__PURE__*/React.createElement(MDCFormRadio, {
      label: "Scheduled fetch",
      name: "radio-upload",
      id: "fetch",
      onCheckedChange: this.onCheckedChange,
      checked: this.state.uploadType === 'fetch'
    }), /*#__PURE__*/React.createElement("div", {
      className: "radio-subtext"
    }, "You'll host a file on your website that contains data and schedule a regular time for Plunk to fetch updates."), /*#__PURE__*/React.createElement(MDCFormRadio, {
      label: "Upload",
      name: "radio-upload",
      id: "manual",
      onCheckedChange: this.onCheckedChange,
      checked: this.state.uploadType === 'manual'
    }), /*#__PURE__*/React.createElement("div", {
      className: "radio-subtext"
    }, "Manually upload a file from your computer."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("button", {
      className: "ui-button primary small icon",
      onClick: this.onContinueClick
    }, "Continue ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "arrow_right")))), this.state.showFetchScreen && /*#__PURE__*/React.createElement(Fetch, {
      data: this.props.data,
      showDeleteButton: this.state.showDeleteButton,
      onSaveFetch: this.onSaveFetch,
      onFetchBack: this.onFetchBack
    }), this.state.showUploadScreen && /*#__PURE__*/React.createElement(FileUpload, {
      postUrl: this.state.postUrl,
      onBeforeUpload: this.onBeforeUpload,
      onUploadError: this.onUploadError,
      onUploadComplete: this.onUploadComplete,
      onUploadProgressComplete: this.onUploadProgressComplete,
      onUploadBack: this.onUploadBack,
      ref: ref => this.fileUpload = ref
    }), this.state.showMessage && /*#__PURE__*/React.createElement(AlertMessage, {
      message: this.state.message,
      cls: this.state.messageType
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
  }
}
export class UpdateProductViewComponent extends BaseDataViewComponent {
  constructor(props) {
    super(props);
  }
  fetchData2() {
    setTimeout(() => {
      this.allowRender = true;
      this.data = {};
      this.forceUpdate();
    }, 100);
  }
  fetchData() {
    var Service = ServiceFactory.getType('/product/schedule', 'product');
    var service = new Service();
    service.get({}, (err, data) => {
      if (!err) {
        console.log(data);
        this.allowRender = true;
        this.data = data;
        this.forceUpdate();
      } else {
        this.error = true;
        this.errorMessage = err.message;
        this.allowRender = true;
        this.forceUpdate();
      }
    });
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  UpdateProductViewComponent
};